// FILE: src/store/index.jsx (FULLY UPDATED)

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// --- THIS IS THE FIX: All state logic is now imported from Slices ---
import { DateSlice } from "./Slices/DateSlice";
import { UntilDateSlice } from "./Slices/UntilDateSlice";
import { SideSlice } from "./Slices/SIdeSlice";
import { ProfileSlice, SubscriptionSlice } from "./Slices/ProfileSlice";
import { FilterSlice } from "./Slices/FilterSlice";
import { AudienceSlice } from "./Slices/AudienceSlice";
import { ImpressionSlice } from "./Slices/ImpressionSlice";
import { EngagmentSlice } from "./Slices/EngagementSlice";
import onboardingReducer from "./Slices/OnboardingSlice";
import groupReducer from "./Slices/GroupSlice";
import { AnalyticsSlice } from "./Slices/AnalyticsSlice";
import libraryReducer from "./Slices/librarySlice";
import calendarFilterReducer from "./Slices/CalendarFilterSlice";
import dashboardReducer from "./Slices/DashboardSlice";
import locationReducer from "./Slices/LocationSlice"; // From our previous step

// --- Persist configs remain the same ---
const onboardingPersistConfig = {
  key: "onboarding",
  storage,
};

const groupsPersistConfig = {
  key: "groups",
  storage,
};

export const onboardingPersistedReducer = persistReducer(
  onboardingPersistConfig,
  onboardingReducer
);
export const groupsPersistedReducer = persistReducer(
  groupsPersistConfig,
  groupReducer
);

// --- THIS IS THE FIX: The rootReducer now combines all the slice reducers ---
const rootReducer = combineReducers({
  SinceDates: DateSlice.reducer,
  UntilDates: UntilDateSlice.reducer,
  SideBarName: SideSlice.reducer,
  Profiles: ProfileSlice.reducer,
  subscription: SubscriptionSlice.reducer,
  Filter: FilterSlice.reducer,
  AudienceGrow: AudienceSlice.reducer,
  Impression: ImpressionSlice.reducer,
  Engagement: EngagmentSlice.reducer,
  Analytics: AnalyticsSlice.reducer,
  onboarding: onboardingPersistedReducer,
  groups: groupsPersistedReducer,
  library: libraryReducer,
  calendar: calendarFilterReducer,
  dashboard: dashboardReducer,
  location: locationReducer,
});

const persistConfig = {
  key: "root",
  storage,
  // Whitelist ensures only these parts of the state are saved to local storage
  whitelist: ["onboarding", "groups"], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };